import React from 'react';
import {Checkbox ,FormControl,FormGroup,FormControlLabel,TextField} from '@material-ui/core'
import {useSelector} from 'react-redux'
import {isEmpty} from 'lodash'
import IntlMessages from 'util/IntlMessages';
function CheckBoxInput(props) {
    const LeverantoList = useSelector(state => state.accountsData.LeventorList)
    // const Afid = useSelector(state => state.auth.authUser.user_Afid)
    const onChangeHandle = (e)=>{
        let Nstate = props.Mstate.map(item =>{
            if(item.Meta === props.Meta){
                return {Meta:props.Meta,Value:e.target.value,Checked:true}
            }else{
                return item
            }
        })
        props.onChangeMstate(Nstate)
    }
    const ChangeMstate=(e)=>{
        let Nstate = props.Mstate.map(item =>{
            if(item.Meta === props.Meta){
                return {Meta:props.Meta,Value:-1,Checked:e.target.checked}
            }else{
                return item
            }
        })
        props.onChangeMstate(Nstate)
    }
   
    return (
        <>
             <FormControl component="fieldset" fullWidth>
                <FormGroup aria-label="position"  row>
                <FormControlLabel
                value={true}    
                style={{ width:"100%" }}       
                      
                control={
                <Checkbox color="primary" 
                checked={props.Mstate.filter(item=>{return item.Meta === props.Meta})[0].Checked}
                onChange={ChangeMstate}
                />
                }
                label={<>
                <TextField
                    variant="outlined"
                    fullWidth
                     
                    label={`${props.Meta}:`}
                    size="small"
                    name={`${props.Meta}`}
                    select
                    value={props.Mstate.filter(item=>{return item.Meta === props.Meta})[0].Value}
                    disabled={!props.Mstate.filter(item=>{return item.Meta === props.Meta})[0].Checked}
                    SelectProps={{native: true,}}
                    InputLabelProps={{shrink: true,}}
                    onChange={onChangeHandle}
                    >
                    <option key={-1} value={-1}><IntlMessages id="All"/></option>
                {            
                    !isEmpty(LeverantoList)?
                    LeverantoList.map((option,index) => (
                        <option key={index} value={option.leverantor}>
                            {option.leverantor}
                        </option>
                    )):""}
                </TextField>  
                </>}
                labelPlacement={"end"}
                />
                </FormGroup>
                
             </FormControl>
        </>
    );
}

export default CheckBoxInput;